export const colors = {
  black: "#000000",
  blackTransparent: "rgba(0,0,0,0.60)",
  blackText: "#000000DE",
  greyDark: "#767676",
  greyLunaDemo: "#acb3c1",
  greyLuna: "#c7c8c8",
  greyLight: "#f9f9f9",
  white: "#fff",
  green: "#008b40",
  greenDark: "#005a2d",
  greenLight: "#dae8da",
  greenLightContrast: "#2E7D32",
  activeGreen: "#44b700",
  purple: "#9C27B0",
  purpleDark: "#6A1B9A",
  purpleLight: "#9C27B01F",
  violet: "#8289DD",
  violetDark: "#5C6BC0",
  violetLight: "#8289DD1F",
  blueLight: "rgba(25, 118, 210, 0.08)",
  blue: "#1976D2",
  blueDark: "#0D47A1",
  blueGoogle: "#4285f4",
  redDark: "#970000",
  red: "#ea526f",
  redBackground: "rgba(253, 237, 237, 1)",
  redLight: "#D32F2F",
  redLightContrast: "#D32F2F1F",
  redBackgroundText: "rgb(95, 33, 32)",
  orange: "#ED6C02",
  orangeLight: "#ED6C021F",
  orangeLighter: "#FFF4E5",
  orangeDark: "#663C00",
  yellow: "#FDC02F",
  yellowLight: "#fdf3da"
};

export const purplePalette = { color: colors.purple, backgroundColor: colors.purpleLight };
export const violetPalette = { color: colors.violet, backgroundColor: colors.violetLight };
export const bluePalette = { color: colors.blueGoogle, backgroundColor: colors.blueLight };
export const orangePalette = { color: colors.white, backgroundColor: colors.orange };

export const darkPalette = {
  purplePalette: { color: colors.white, backgroundColor: colors.purpleDark },
  violetPalette: { color: colors.white, backgroundColor: colors.violetDark },
  bluePalette: { color: colors.white, backgroundColor: colors.blueDark },
  orangePalette: { color: colors.white, backgroundColor: colors.orangeDark }
};
